var templateUrl = require("../../views/directives/burstDifference.html");
import h from "../helper/helper";
import ChunkLoader from "../messages/chatChunk";
var directivesModule = require("directives/directivesModule");
var BurstDifferenceComponentController = /** @class */ (function () {
    function BurstDifferenceComponentController() {
    }
    BurstDifferenceComponentController.prototype.differentDay = function () {
        if (this.noDates || !this.chat || !this.chat.getLatestChunk) {
            return false;
        }
        if (this.burst && this.previousBurst) {
            return !this.burst.sameDay(this.previousBurst);
        }
        return true;
    };
    BurstDifferenceComponentController.prototype.differentChunk = function () {
        if (!this.chat || !this.chat.getLatestChunk) {
            return false;
        }
        if (this.burst && this.previousBurst) {
            return !this.burst.sameChunk(this.previousBurst);
        }
        if (this.previousBurst) {
            return this.previousBurst.getChunkID() !== this.chat.getLatestChunk();
        }
        return true;
    };
    BurstDifferenceComponentController.prototype.chunksBetweenBursts = function () {
        if (!this.previousBurst) {
            return [];
        }
        var currentChunkID = this.burst ? this.burst.getChunkID() : this.chat.getLatestChunk();
        return this.getChunksBetween(ChunkLoader.getLoaded(currentChunkID), ChunkLoader.getLoaded(this.previousBurst.getChunkID())).reverse();
    };
    BurstDifferenceComponentController.prototype.addedReceiver = function (chunk) {
        var currentReceiveers = chunk.getReceivers();
        var previousReceiveers = ChunkLoader.getLoaded(chunk.getPredecessorID()).getReceivers();
        return currentReceiveers.filter(function (partner) { return previousReceiveers.indexOf(partner) === -1; });
    };
    BurstDifferenceComponentController.prototype.removedReceiver = function (chunk) {
        var currentReceiveers = chunk.getReceivers();
        var previousReceiveers = ChunkLoader.getLoaded(chunk.getPredecessorID()).getReceivers();
        return previousReceiveers.filter(function (partner) { return currentReceiveers.indexOf(partner) === -1; });
    };
    BurstDifferenceComponentController.prototype.changedTitle = function (chunk) {
        var currentTitle = chunk.getTitle();
        var previousTitle = ChunkLoader.getLoaded(chunk.getPredecessorID()).getTitle();
        if (currentTitle !== previousTitle) {
            return currentTitle;
        }
    };
    BurstDifferenceComponentController.prototype.getCreator = function (chunk) {
        return chunk.getReceivers().find(function (user) { return user.id === chunk.getCreator(); });
    };
    BurstDifferenceComponentController.prototype.getChunksBetween = function (newerChunk, olderChunk) {
        if (newerChunk.getID() === olderChunk.getID()) {
            return [];
        }
        var predecessor = ChunkLoader.getLoaded(newerChunk.getPredecessorID());
        return [newerChunk].concat(this.getChunksBetween(predecessor, olderChunk));
    };
    BurstDifferenceComponentController.prototype.hasPreviousChunk = function () {
        return Boolean(this.previousBurst);
    };
    BurstDifferenceComponentController.prototype.receiver = function () {
        if (this.burst) {
            return ChunkLoader.getLoaded(this.burst.getChunkID()).getPartners();
        }
        return ChunkLoader.getLoaded(this.chat.getLatestChunk()).getPartners();
    };
    BurstDifferenceComponentController.prototype.getTime = function () {
        if (this.burst) {
            return this.burst.firstItem().getTime();
        }
        var latestChunk = ChunkLoader.getLoaded(this.chat.getLatestChunk());
        return h.parseDecimal(latestChunk.getTime());
    };
    BurstDifferenceComponentController.prototype.getChunk = function () {
        var burstChunkID = this.burst ? this.burst.getChunkID() : this.chat.getLatestChunk();
        return ChunkLoader.getLoaded(burstChunkID);
    };
    BurstDifferenceComponentController.prototype.hasTitleDifference = function () {
        if (!this.previousBurst) {
            return false;
        }
        var burstChunk = this.getChunk();
        var previousBurstChunk = ChunkLoader.getLoaded(this.previousBurst.getChunkID());
        return burstChunk.getTitle() !== previousBurstChunk.getTitle();
    };
    BurstDifferenceComponentController.prototype.getTitle = function () {
        this.getChunk().getTitle();
    };
    Object.defineProperty(BurstDifferenceComponentController, "$inject", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    return BurstDifferenceComponentController;
}());
var burstDifferenceComponent = {
    templateUrl: templateUrl,
    controller: BurstDifferenceComponentController,
    controllerAs: "$ctrl",
    bindings: {
        chat: "<",
        burst: "<",
        previousBurst: "<",
        noDates: "<"
    }
};
directivesModule.component("burstDifference", burstDifferenceComponent);



//////////////////
// WEBPACK FOOTER
// ./js/directives/burstDifference.ts
// module id = S/Pn
// module chunks = 1 2